import React, { useState } from 'react';
import { Modal, List, Button, Typography } from 'antd';

const { Title, Text } = Typography;

const RegistrationSelectModal = ({ open, registrations, onSelect, onCancel }) => {
  const [selectedId, setSelectedId] = useState(null);

  return (
    <Modal
      open={open}
      title={<Title level={4}>Select a Registration</Title>}
      onCancel={onCancel}
      footer={null}
      centered
    >
      <List
        bordered
        dataSource={registrations}
        renderItem={item => (
          <List.Item
            style={{
              background: selectedId === item.ID ? '#e6f7ff' : 'white',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <Text strong>{item.registration_name}</Text>
              {item.year && <Text type="secondary" style={{ marginLeft: 8 }}>({item.year})</Text>}
            </div>
            <Button
              type="primary"
              onClick={e => {
                e.stopPropagation();
                onSelect(item);
              }}
            >
              Select
            </Button>
          </List.Item>
        )}
      />
      <div style={{ textAlign: 'right', marginTop: 16 }}>
        <Button onClick={onCancel}>Cancel</Button>
      </div>
    </Modal>
  );
};

export default RegistrationSelectModal; 